exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select2-results .select2-highlighted{color:#fff!important;background-color:#337ab7}.select2-drop-active{width:200px!important}.vue-tags-input{max-width:100%!important;float:left;margin-right:50px}.vue-tags-input .ti-input{border:none}.ti-tag{color:#fff!important;border:1px solid #cbd5dd;background-color:#757575!important;font-size:14px!important;flex-direction:row-reverse}.ti-tag .ti-actions{margin-left:0!important;margin-right:2px;font-size:1em!important}.ti-tag .ti-actions .ti-icon-close{font-weight:900!important}.filter-clear-button{position:absolute;right:20px;top:22%}", ""]);

// exports
